import * as React from 'react';
import { MaintButton } from '../styles';
import { MaintenanceButtonProps } from '../types';

export const MaintenanceButton = (props: MaintenanceButtonProps) => {
  const { onClick } = props;
  return <MaintButton onClick={onClick} data-testid="maintenanceLoginButton" style={props.style} />;
};
